import { buildGraphqlQuery, cleanQuery } from '../data/utils';

export async function infopagesItemsRequest(fetch, payload = {}) {
  const allowedKeys = ['limit', 'order', 'fields', 'slug'];
  const cleanedQuery = cleanQuery(payload, allowedKeys);
  const graphqlQuery = buildGraphqlQuery(cleanedQuery);

  return fetch('/graphql', {
    body: JSON.stringify({
      query: `{
        pages${graphqlQuery} {
          items {
            id
            title
            html
            meta {
              first_published_at
              slug
            }
          }
        }
      }`,
    }),
  })
    .then(response => response.json())
    .then(data => data.data.pages);
}

export async function infopageItemRequest(fetch, id) {
  return fetch('/graphql', {
    body: JSON.stringify({
      query: `{
        page(id: ${id}) {
          id
          title
          html
          meta {
            first_published_at
            slug
            seo_title
            search_description
          }
        }
      }
      `,
    }),
  })
    .then(response => response.json())
    .then(data => data.data.page);
}

export const SET_INFOPAGE_ITEM = 'SET_INFOPAGE_ITEM';

export function setInfoPageItem(payload) {
  return {
    type: SET_INFOPAGE_ITEM,
    payload,
  };
}
